export default __webpack_public_path__ + "assets/images/e4539a48fe75c85c5d132b6eda44e62d.png";